import { type CreateMediaInputType } from '@shelflix/schemas/media/create';
import { create } from 'zustand';

interface MediaFormStore {
  formData: Partial<CreateMediaInputType>;
  setFormData: (data: Partial<CreateMediaInputType>) => void;
  resetForm: () => void;
}

export const useMediaFormStore = create<MediaFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
